import {formatBytes} from "../../../utils2";
import React from "react";
import {Link} from "react-router-dom";

export function AvailableSpaceBar({announcementSize, abSubscription, article_title, remaining_days}) {

    const barWidth = announcementSize < abSubscription ? `${(announcementSize * 100) / abSubscription}%` : '100%'

    const isAlertSpace = (announcementSize / abSubscription) * 100 > 80
    const barColor = isAlertSpace ? "border-danger" : "border-info"


    return <>


        <div className="d-flex justify-content-center align-items-center my-2">
            <div className="w-100 mx-2">
                <div className="d-flex flex-column gap-2">
                    <div className="d-flex align-items-center">
                        <div>AB server usage:</div>
                        <div className="ms-auto">
                            <div>{`${formatBytes(announcementSize)} of ${formatBytes(abSubscription)}`}</div>
                        </div>
                    </div>

                    <div className="w-100 position-relative" style={{height: '30px'}}>
                        {/* Full bar in secondary color */}
                        <div
                            className="border-bottom border-5 border-light-subtle "
                            style={{
                                width: '100%',
                                position: 'absolute',
                                // bottom: 0,
                                // left: 0
                            }}
                        />

                        {/* Progress bar in info color */}
                        <div
                            className={`border-bottom border-5 ${barColor}`}
                            style={{
                                width: barWidth,
                                position: 'absolute',
                                // bottom: 0,
                                // left: 0,
                                transition: 'width 0.3s ease'
                            }}
                        />
                    </div>

                </div>
                <div className="d-flex align-items-center">
                    <div className="d-flex flex-column flex-md-row gap-md-2 align-items-md-center">
                        <div>{article_title} </div>
                        {remaining_days > 0 && <div
                            className="text-wrap text-muted small">{`${remaining_days} ${remaining_days > 1 ? "days" : "day"}  remaining`}</div>}
                    </div>
                    <div className="ms-auto">
                        <Link to="/shop/products?tags=8ebf3eac-a4a7-46ff-9051-86945593c4ab"
                              className="mt-0 link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover"
                        >Upgrade</Link>
                    </div>
                </div>
                <div className="mt-2"/>
                {isAlertSpace &&
                    <div className="text-danger small"><i className="bi bi-exclamation-circle me-2"/>Your server storage is almost full. Upgrade now to add more
                        announcements.</div>}
                {(article_title !== "No subscription" && remaining_days <= 15) &&
                    <div className="text-danger small"><i className="bi bi-exclamation-circle me-2"/>Your subscription is about to expire. To avoid losing your
                        announcements, upgrade now.</div>}
            </div>
        </div>
    </>
}